import { createSlice } from '@reduxjs/toolkit';
import { MonthlyDeclarationOverviewItem, UserRegime } from '../../@types/TaxProfile';
import { AnnualPreviewData } from '../../@types/AnnualPreview.type';
import { AllFft } from '../../@types/FFT.type';
interface TaxState {
	isLoading: {
		declarationsOverviewDetail: boolean;
		userIsPlatec: boolean;
		regimes: boolean;
	};
	declarationsOverviewDetail: MonthlyDeclarationOverviewItem[] | null;
	currentAnnualDeclaration: MonthlyDeclarationOverviewItem | null;
	userIsPlatec: boolean;
	annualDeclarationOverview: AnnualPreviewData | null;
	userRegimes: UserRegime[] | null;
	allFFT: AllFft | null;
}

const initialState: TaxState = {
	isLoading: {
		declarationsOverviewDetail: false,
		userIsPlatec: false,
		regimes: false,
	},
	declarationsOverviewDetail: null,
	userIsPlatec: false,
	annualDeclarationOverview: null,
	userRegimes: null,
	currentAnnualDeclaration: null,
	allFFT: null,
};

export const taxSlice = createSlice({
	name: 'tax',
	initialState,
	reducers: {
		setMonthlyDeclarationsOverview: (state, action) => {
			state.declarationsOverviewDetail = action.payload;
		},
		setUserIsPlatec: (state, action) => {
			state.userIsPlatec = action.payload;
		},
		setIsLoadingTax: (state, action) => {
			state.isLoading = {
				...state.isLoading,
				[action.payload.key]: action.payload.value,
			};
		},
		setAnnualDeclarationOverview: (state, action) => {
			state.annualDeclarationOverview = action.payload;
		},
		setUserRegimes: (state, action) => {
			state.userRegimes = action.payload;
		},
		setCurrentAnnualDeclaration: (state, action) => {
			state.currentAnnualDeclaration = action.payload;
		},
		setAllFFT: (state, action) => {
			state.allFFT = action.payload;
		},
	},
});

export const {
	setMonthlyDeclarationsOverview,
	setUserIsPlatec,
	setIsLoadingTax,
	setAnnualDeclarationOverview,
	setUserRegimes,
	setCurrentAnnualDeclaration,
	setAllFFT,
} = taxSlice.actions;

export default taxSlice.reducer;
